module.exports = __webpack_public_path__ + "static/media/Myriad-Pro-Regular.7ac043ce.ttf";